import React, { useState, useEffect, useContext, createContext } from 'react'

const solidColorContext = createContext();
export const Usesolidcolorcontext = () => useContext(solidColorContext);

const useSolidColor = () => {
    const [copy, setCopy] = useState(null);
    const [open, setOpen] = useState(false);

    const handleColors = (colorHexCode) => {
        console.log(colorHexCode, "==== colorHexCode");
        const copyCode = colorHexCode;
        const text = document.createElement("textarea");
        document.body.appendChild(text);
        text.value = copyCode;
        text.select();
        document.execCommand("copy");
        document.body.removeChild(text);
        setCopy(colorHexCode);
        localStorage.setItem("Copy", copy);
        const getCopiedItem = localStorage.getItem("Copy");
        if (getCopiedItem === "null" || getCopiedItem !== "null") {
            setTimeout(function () {
                setCopy(null);
            }, 3000);
        }
    };

    const handlePremiumColor = (colorHexCode) => {
        handleColors(colorHexCode);
    }
    const handleBlueColor = (colorHexCode) => {
        handleColors(colorHexCode);
    };
    const handleGreenColor = (colorHexCode) => {
        handleColors(colorHexCode);
    };
    const handleYellowColor = (colorHexCode) => {
        handleColors(colorHexCode);
    };
    const handleMixColor = (colorHexCode) => {
        handleColors(colorHexCode);
    };

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };

    return {
        copy,
        open,
        handleColors,
        handlePremiumColor,
        handleBlueColor,
        handleGreenColor,
        handleYellowColor,
        handleMixColor,
        toggleDrawer

    }
}

export function ProvideSolidColor({ children }) {
    const solidColor = useSolidColor();
    return <solidColorContext.Provider value={solidColor}>{children}</solidColorContext.Provider>
}
